import { useAuth } from '../contexts/AuthContext';
import { useLocale } from '../contexts/LocaleContext';
import { useToast } from '../contexts/ToastContext';
import { API_BASE } from '../config';

interface UseDeleteCommentOptions {
  onCommentsUpdated?: () => Promise<void> | void;
}

interface UseDeleteCommentResult {
  deleteComment: (commentId: string) => Promise<boolean>;
}

export const useDeleteComment = (options: UseDeleteCommentOptions = {}): UseDeleteCommentResult => {
  const { token } = useAuth();
  const { t } = useLocale();
  const { showToast, showErrorToast } = useToast();

  const deleteComment = async (commentId: string): Promise<boolean> => {
    if (!token) {
      return false;
    }

    try {
      const response = await fetch(`${API_BASE}/api/comments/${commentId}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        showToast(t('comment_resolved'));
        if (options.onCommentsUpdated) {
          await options.onCommentsUpdated();
        }
        return true;
      }

      showErrorToast(t('failed_to_resolve_comment'));
      return false;
    } catch (err) {
      console.error('Error deleting comment:', err);
      showErrorToast(t('failed_to_resolve_comment'));
      return false;
    }
  };

  return { deleteComment };
};


